import FormColorControl from './FormColorControl';
import React from 'react';
import { formActions, useAppDispatch, useAppSelector } from '../../data/store';
import { IColor } from '../../interfaces';
import CloseIcon from '../icons/CloseIcon';

const FormColors = () => {

    const dispatch = useAppDispatch();
    const colors = useAppSelector(store => store.form.colors);

    const updateColor = (updatedColor: IColor, oldColorId: string) => {

        const oldColorIndex = colors.findIndex(c => c.cid === oldColorId);
        if(oldColorIndex === -1) return;

        const copy = [...colors];
        copy[oldColorIndex] = updatedColor;

        dispatch(
            formActions.main({
                colors: copy,
            })
        );
    };

    /**
     * remove color by id
     */
    const removeColor = (colorId: string) => {
        const oldColorIndex = colors.findIndex(c => c.cid === colorId);
        if(oldColorIndex === -1) return;

        const copy = [...colors];
        copy.splice(oldColorIndex, 1);

        dispatch(
            formActions.main({
                colors: copy,
            })
        );
    };

    return (
        <>
            {
                colors.map((color) => {

                    return (
                        <div key={ color.cid } className="flex">

                            <FormColorControl
                                rgbaColor={ color }
                                onChange={ (updatedColor) => {
                                    updatedColor.cid = color.cid;
                                    updateColor(updatedColor, color.cid);
                                }}
                            />

                            <button
                                type="button"
                                className="mx-2"
                                title="Remove Color"
                                onClick={ () => {
                                    removeColor(color.cid);
                                }}>
                                <CloseIcon width="15" height="15" />
                            </button>
                        </div>
                    )
                })
            }

        </>
    )
}

export default FormColors;